import React from "react";
import styled from "styled-components";
import authBg from "../../Assets/Images/auth-cover.png";
import dashIcon from "../../Assets/Images/pattern.svg";

const AuthRightContainerStyle = styled.div`
    height:100vh;
    display:flex;
    background: linear-gradient(327.38deg, #E8F0FB 0%, #F5F8FE 47.92%, #FFFFFF 100%);
    .vCenterBlock{
        .authCoverImage{
            width:66%;
            margin:0 auto 70px;
            position:relative;
            box-shadow:4px 12px 38px -20px #8ba4c9;
            img{
                width:100%;
                position:relative;
                z-index:1;
            }
        }
        h2,p{
            text-align:center;
        }
        h2{
            font-size:18px;
            line-height:28px;
            color:var(--color-text-title);
            position:relative;
            z-index:1;
        }
        p{
            font-family:var(--sf-pro-text);
            font-size:16px;
            line-height:24px;
            color:var(--light-text);
        }
    }
    @media(max-width:1280px){
        .vCenterBlock{
            .authCoverImage{
                width:75%;
            }
        }
    }
    @media(max-width:1200px){
        .vCenterBlock{
            h2{
                line-height:24px;
            }
            p{
                font-size:14px;
                line-height:20px;
            }
        }
    }
    @media(max-width:992px){
        height:100%;
        padding:40px 0 50px;
    }
    @media(max-width:640px){
        h2{
            font-size:20px;
        }
        p{
            font-size:14px;
            br{
                display:none;
            }
        }
    }
    @media(max-width:480px){
        h2, p{
            padding:0px 15px;
            br{
                display:none;
            }
        }
    }
`;
const DashIconBox = styled.div`
    position:absolute;
    bottom:-120px;
    right:-85px;
    width:280px;
    height:260px;
    background-image: url(${dashIcon});
    background-repeat:no-repeat;
    @media(max-width:1280px){
        right:-40px;
    }
`;
const AuthRightContainer = () => {
    return (<AuthRightContainerStyle>
    <div className="flexBlock" style={{justifyContent:"center"}}>
        <div className="vCenterBlock">
            <div className="authCoverImage">
                <img src={authBg} alt="App Screen"/>
                <DashIconBox></DashIconBox>
            </div>
            <h2>Optimize trim loss and reduce production <br/>costs in paper production</h2>
            <p>First of its kind deckle management system with <br /> integrated CRM and Production Management system  </p>
        </div>
    </div>
    </AuthRightContainerStyle>);
}

export default AuthRightContainer;